export const IMAGE_HOST_PATH =
  (process.env.NODE_ENV === "development"
    ? location.origin + "/"
    : IMAGE_HOST) + "images/";
export default {
  // 安全守护
  securityGuard: {
    privacy: IMAGE_HOST_PATH + "securityGuard/sg-privacy.png",
    privacyH5: IMAGE_HOST_PATH + "securityGuard/sg-privacy-h5.png",
    privacyPad: IMAGE_HOST_PATH + "securityGuard/sg-privacy-pad.png",
    auth: IMAGE_HOST_PATH + "securityGuard/sg-auth.png",
    authH5: IMAGE_HOST_PATH + "securityGuard/sg-auth-h5.png",
    authPad: IMAGE_HOST_PATH + "securityGuard/sg-auth-pad.png",
  },
};

// 首屏
export const FIRST_SCREEN = {
  fs1: IMAGE_HOST_PATH + "firstScreen/fs_1.png",
  fs2: IMAGE_HOST_PATH + "firstScreen/fs_2.png",
  fs3: IMAGE_HOST_PATH + "firstScreen/fs_3.png",
  fs4: IMAGE_HOST_PATH + "firstScreen/fs_4.png",
  fs5: IMAGE_HOST_PATH + "firstScreen/fs_5.png",
  fs360bg: IMAGE_HOST_PATH + "firstScreen/fs-360-bg.png",
  fs_676_1: IMAGE_HOST_PATH + "firstScreen/fs-676-1.png",
  fs_676_2: IMAGE_HOST_PATH + "firstScreen/fs-676-2.png",
  fs_676_3: IMAGE_HOST_PATH + "firstScreen/fs-676-3.png",
  fs_676_4: IMAGE_HOST_PATH + "firstScreen/fs-676-4.png",
  fs_676_5: IMAGE_HOST_PATH + "firstScreen/fs-676-5.png",
};
// 新设计
export const NEW_DESIGN = {
  bg: IMAGE_HOST_PATH + "newDesign/nd-bg.png",
  slide1: IMAGE_HOST_PATH + "newDesign/nd-slide-1.png",
  slide2: IMAGE_HOST_PATH + "newDesign/nd-slide-2.png",
  slide3: IMAGE_HOST_PATH + "newDesign/nd-slide-3.png",
  phoneModel: IMAGE_HOST_PATH + "newDesign/nd-phone-model.png",
  ls676bg: IMAGE_HOST_PATH + "newDesign/nd-ls-676-bg.png",
  ls360bg: IMAGE_HOST_PATH + "newDesign/nd-ls-360-bg.png",
  padSlide1: IMAGE_HOST_PATH + "newDesign/nd-slide1-pad.png",
  padSlide2: IMAGE_HOST_PATH + "newDesign/nd-slide2-pad.png",
  padSlide3: IMAGE_HOST_PATH + "newDesign/nd-slide3-pad.png",
  h5Slide1: IMAGE_HOST_PATH + "newDesign/nd-slide1-h5.png",
  h5Slide2: IMAGE_HOST_PATH + "newDesign/nd-slide2-h5.png",
  h5Slide3: IMAGE_HOST_PATH + "newDesign/nd-slide3-h5.png",
  x300PhoneModel: IMAGE_HOST_PATH + "fluidEngine/se-phone-x300.png", // x300机模
};
// 秒抢引擎
export const SECOND_GRAB_ENGINE = {
  bg: IMAGE_HOST_PATH + "secondGrabEngine/sge-bg.png",
  slide2: IMAGE_HOST_PATH + "secondGrabEngine/slide2.png",
  slide3: IMAGE_HOST_PATH + "secondGrabEngine/slide3.png",
  hand: IMAGE_HOST_PATH + "secondGrabEngine/hand.png",
  padSlide1: IMAGE_HOST_PATH + "secondGrabEngine/sge-slide1-pad.png",
  padSlide2: IMAGE_HOST_PATH + "secondGrabEngine/sge-slide2-pad.png",
  padSlide3: IMAGE_HOST_PATH + "secondGrabEngine/sge-slide3-pad.png",
  h5Slide1: IMAGE_HOST_PATH + "secondGrabEngine/sge-slide1-h5.png",
  h5Slide2: IMAGE_HOST_PATH + "secondGrabEngine/sge-slide2-h5.png",
  h5Slide3: IMAGE_HOST_PATH + "secondGrabEngine/sge-slide3-h5.png",
};
// 5年持久如新
export const FIVE_YEARS_DURABILITY = {
  certificate: IMAGE_HOST_PATH + "fiveYearsDurability/fyd-certificate.png",
  earth: IMAGE_HOST_PATH + "fiveYearsDurability/fyd-earth.png",
  light: IMAGE_HOST_PATH + "fiveYearsDurability/fyd-light.png",
  padBg: IMAGE_HOST_PATH + "fiveYearsDurability/fyd-bg-pad.png",
  h5Bg: IMAGE_HOST_PATH + "fiveYearsDurability/fyd-bg-h5.png",
};
// 光栅壁纸
export const GRATING_WALLPAPER = {
  wallpaperBlueH5: IMAGE_HOST_PATH + "gratingWallpaper/gw-bg-blue-h5.png",
  wallpaperBluePad: IMAGE_HOST_PATH + "gratingWallpaper/gw-bg-blue-pad.png",
  wallpaperOrangeH5: IMAGE_HOST_PATH + "gratingWallpaper/gw-bg-orange-h5.png",
  wallpaperOrangePad: IMAGE_HOST_PATH + "gratingWallpaper/gw-bg-orange-pad.png",
  wallpaperGreyH5: IMAGE_HOST_PATH + "gratingWallpaper/gw-bg-grey-h5.png",
  wallpaperGreyPad: IMAGE_HOST_PATH + "gratingWallpaper/gw-bg-grey-pad.png",
  phoneBluePad: IMAGE_HOST_PATH + "gratingWallpaper/gw-phone-blue-pad.png",
  phoneOrangePad: IMAGE_HOST_PATH + "gratingWallpaper/gw-phone-orange-pad.png",
  phoneGreyPad: IMAGE_HOST_PATH + "gratingWallpaper/gw-phone-grey-pad.png",
};
// 个性锁屏
export const CUSTOMISABLE_LOCK_SCREEN = {
  wallpaper1: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper4.png",
  wallpaper2: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper5.png",
  wallpaper3: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper6.png",
  wallpaper4: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper7.png",
  wallpaper5: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper8.png",
  wallpaper6: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper9.png",
  wallpaper7: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper10.png",
  wallpaper8: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper11.png",
  wallpaper9: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper12.png",
  wallpaper10: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper13.png",
  wallpaper11: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper14.png",
  wallpaper12: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper1.png",
  wallpaper13: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper2.png",
  wallpaper14: IMAGE_HOST_PATH + "customisableLockScreen/sl-wallpaper3.png",
};
// 流畅引擎
export const FLUID_ENGINE = {
  dualRenderingArchitectureBG: IMAGE_HOST_PATH + "fluidEngine/fe-bg-dra.png", // 双渲染架构
  hyperCoreComputingBG: IMAGE_HOST_PATH + "fluidEngine/fe-bg-hcc.png", // 超核计算
  photonicStorageBG: IMAGE_HOST_PATH + "fluidEngine/fe-bg-ps.png", // 光子储存
  wallpaperPhone: IMAGE_HOST_PATH + "fluidEngine/se-bg-phone.png", // 流畅引擎360
  wallpaperPad: IMAGE_HOST_PATH + "fluidEngine/se-bg-pad.png", // 流畅引擎pad
  wallpaperPC: IMAGE_HOST_PATH + "fluidEngine/se-bg-pc.png", // 三大技术pc
  progress1: IMAGE_HOST_PATH + "fluidEngine/se-pg-long.svg", // 进度条长
  progress2: IMAGE_HOST_PATH + "fluidEngine/se-pg-point.svg", // 进度条点
  phoneModel: IMAGE_HOST_PATH + "fluidEngine/se-phone-x300.png", // x300机模
  phoneModel2: IMAGE_HOST_PATH + "fluidEngine/se-phone-x300-no-camera.png", // x300无前摄机模
  phoneModel3: IMAGE_HOST_PATH + "fluidEngine/se-phone-x300-row.png", // x300横向机模
  fingerPointer1: IMAGE_HOST_PATH + "fluidEngine/se-phone-finger1.png", // 手指长按
  fingerPointer2: IMAGE_HOST_PATH + "fluidEngine/se-phone-finger2.png", // 手指上滑
  phoneWallpaper7: IMAGE_HOST_PATH + "fluidEngine/sw-phone-wallpaper7.png", // 后台近期应用
  phoneWallpaper8: IMAGE_HOST_PATH + "fluidEngine/sw-phone-wallpaper8.png", // 桌面图标拖动
  phoneWallpaper9: IMAGE_HOST_PATH + "fluidEngine/sw-phone-wallpaper9.png", // 帧形变
  phoneWallpaper10: IMAGE_HOST_PATH + "fluidEngine/sw-phone-wallpaper10.png", // 帧模糊
  phoneWallpaper11: IMAGE_HOST_PATH + "fluidEngine/sw-phone-wallpaper11.png", // 一镜到底
};
// 性能和续航
export const PERFORMANCE_ENDURANCE = {
  wallpaperPhone: IMAGE_HOST_PATH + "performanceEndurance/pe-bg-phone.png", // 能效引擎手机
  wallpaperPC: IMAGE_HOST_PATH + "performanceEndurance/pe-bg-pc.png", // 能效引擎pc
  wallpaperPad: IMAGE_HOST_PATH + "performanceEndurance/pe-bg-pad.png", // 能效引擎pad
  phoneModel1: IMAGE_HOST_PATH + "performanceEndurance/pe-phone-x300.png", // x300幸运彩机模
  phoneWallpaper: IMAGE_HOST_PATH + "performanceEndurance/pe-phone-wallpaper.png", // 微电精灵
  phoneCharger1: IMAGE_HOST_PATH + "performanceEndurance/pe-phone-charger1.png", // 微电精灵插头
  cardBackground: IMAGE_HOST_PATH + "performanceEndurance/pe-card-bg.png", // 系统轻量化蓝圈
  cardBackground2: IMAGE_HOST_PATH + "performanceEndurance/pe-card-bg2.png", // 系统轻量化蓝圈移动端
  phone: IMAGE_HOST_PATH + "performanceEndurance/pe-ddps-phone.png", // 直驱供电手机
}
// 自然舒适
export const NATURAL_COMFORT = {
  h5Bg: IMAGE_HOST_PATH + "naturalComfort/nc-bg-h5.png",
  padBg: IMAGE_HOST_PATH + "naturalComfort/nc-bg-pad.png",
  title: IMAGE_HOST_PATH + "naturalComfort/nc-title.png",
};
// 更多精彩
export const MORE_MODULE = {
  bg360: IMAGE_HOST_PATH + "moreModule/mm-bg-360.png",
  bg528: IMAGE_HOST_PATH + "moreModule/mm-bg-528.png",
};
// 适配计划
export const ADAPTATION_PLAN = {
  logo: IMAGE_HOST_PATH + "adaptationPlan/os-log.png",
  logoH5: IMAGE_HOST_PATH + "adaptationPlan/os-log-h5.png",
  logoH5Dark: IMAGE_HOST_PATH + "adaptationPlan/os-log-h5-dark.png",
  logoPad: IMAGE_HOST_PATH + "adaptationPlan/os-log-pad.png",
  logoPadDark: IMAGE_HOST_PATH + "adaptationPlan/os-log-pad-dark.png",
  bg360: IMAGE_HOST_PATH + "adaptationPlan/ap-bg-360.png",
  bg528: IMAGE_HOST_PATH + "adaptationPlan/ap-bg-528.png",
};
// 更多精彩，一同目睹
export const OTHER_LINK = {
  QRcode: IMAGE_HOST_PATH + "moreLink/ol-QRcode.png",
  FuntouchOS: IMAGE_HOST_PATH + "moreLink/ol-FuntouchOS.png",
  bg360: IMAGE_HOST_PATH + "moreLink/ol-bg-360.png",
  bg528: IMAGE_HOST_PATH + "moreLink/ol-bg-528.png",
};
// 跨生态，都好用
export const CROSS_ECOLOGY = {
  shake: IMAGE_HOST_PATH + "crossEcology/shake.png",
  shakeH5: IMAGE_HOST_PATH + "crossEcology/shake-h5.png",
  shakePad: IMAGE_HOST_PATH + "crossEcology/shake-pad.png",
  file: IMAGE_HOST_PATH + "crossEcology/file-bg.png",
  fileH5: IMAGE_HOST_PATH + "crossEcology/file-bg-h5.png",
  filePad: IMAGE_HOST_PATH + "crossEcology/file-bg-pad.png",
  crossios: IMAGE_HOST_PATH + "crossEcology/crossios.png",
  crossiosH5: IMAGE_HOST_PATH + "crossEcology/crossios-h5.png",
  crossiosPad: IMAGE_HOST_PATH + "crossEcology/crossios-pad.png",
  crosscar: IMAGE_HOST_PATH + "crossEcology/crosscar.png",
  crosscarH5: IMAGE_HOST_PATH + "crossEcology/crosscar-h5.png",
  crosscarPad: IMAGE_HOST_PATH + "crossEcology/crosscar-pad.png",
  crosshome: IMAGE_HOST_PATH + "crossEcology/crosshome.png",
  crosshomeH5: IMAGE_HOST_PATH + "crossEcology/crosshome-h5.png",
  crosshomePad: IMAGE_HOST_PATH + "crossEcology/crosshome-pad.png",
  openInPC: IMAGE_HOST_PATH + "crossEcology/open-in-pc.png",
  miMacHover1: IMAGE_HOST_PATH + "crossEcology/mi-mac-2.png",
  miMac: IMAGE_HOST_PATH + "crossEcology/mi-mac.png",
};
// 呵护你的眼神
export const EYE_CARE = {
  eyebg: IMAGE_HOST_PATH + "eyeCare/eyebg.png",
  eyebgH5: IMAGE_HOST_PATH + "eyeCare/eyebg-h5.png",
  eyebgPad: IMAGE_HOST_PATH + "eyeCare/eyebg-pad.png",
  eyeLeft: IMAGE_HOST_PATH + "eyeCare/eye-left.png",
  eyeLeftH5: IMAGE_HOST_PATH + "eyeCare/eye-left-h5.png",
  eyeLeftPad: IMAGE_HOST_PATH + "eyeCare/eye-left-pad.png",
  eyeRight: IMAGE_HOST_PATH + "eyeCare/eye-right.png",
  eyeRightH5: IMAGE_HOST_PATH + "eyeCare/eye-right-h5.png",
  eyeRightPad: IMAGE_HOST_PATH + "eyeCare/eye-right-pad.png",
};

// 呵护你的眼神
export const TECHNOLOGY = {
  technology1: IMAGE_HOST_PATH + "technologyIlluminate/technology-1.png",
  technology1H5: IMAGE_HOST_PATH + "technologyIlluminate/technology-1-h5.png",
  technology1Pad: IMAGE_HOST_PATH + "technologyIlluminate/technology-1-pad.png",
  // vivo看见
  vivoSee: IMAGE_HOST_PATH + "technologyIlluminate/vivo-see.png",
  vivoSeeH5: IMAGE_HOST_PATH + "technologyIlluminate/vivo-see-h5.png",
  vivoSeePad: IMAGE_HOST_PATH + "technologyIlluminate/vivo-see-pad.png",
  // 组听器直连
  hearingAidConnect: IMAGE_HOST_PATH + "technologyIlluminate/hearing-aid-connect.png",
  hearingAidConnectH5: IMAGE_HOST_PATH + "technologyIlluminate/hearing-aid-connect-h5.png",
  hearingAidConnectPad: IMAGE_HOST_PATH + "technologyIlluminate/hearing-aid-connect-pad.png",
};

// ai
export const AI_SCREEN = {
  bg: IMAGE_HOST_PATH + "aiScreen/bg.png",
  bgH5: IMAGE_HOST_PATH + "aiScreen/bg-h5.png",
  bgPad: IMAGE_HOST_PATH + "aiScreen/bg-pad.png",
  livephoto: IMAGE_HOST_PATH + "aiScreen/livephoto.png",
  vSearch: IMAGE_HOST_PATH + "aiScreen/v-search.png",
  vSearchH5: IMAGE_HOST_PATH + "aiScreen/v-search-h5.png",
  vSearchPad: IMAGE_HOST_PATH + "aiScreen/v-search-pad.png",
  aiSearch: IMAGE_HOST_PATH + "aiScreen/ai-search.png",
  aiSearchH5: IMAGE_HOST_PATH + "aiScreen/ai-search-h5.png",
  aiSearchPad: IMAGE_HOST_PATH + "aiScreen/ai-search-pad.png",
  vMemory: IMAGE_HOST_PATH + "aiScreen/v-memory.png",
  vMemoryH5: IMAGE_HOST_PATH + "aiScreen/v-memory-h5.png",
  vMemoryPad: IMAGE_HOST_PATH + "aiScreen/v-memory-pad.png",
  vInputMethod: IMAGE_HOST_PATH + "aiScreen/v-input-method.png",
  vInputMethodH5: IMAGE_HOST_PATH + "aiScreen/v-input-method-h5.png",
  vInputMethodPad: IMAGE_HOST_PATH + "aiScreen/v-input-method-pad.png",
};
